//adding css
import './section-front.css';
import './regional-section-front.css';

import base from '../base/base';
import header from '../base/header';

import TopVideoPlayer from '../../components/platformPlayer/TopVideoPlayer';
import LazyloadVideo from '../../components/platformPlayer/LazyloadVideo';
import TrackingUtils from '../../components/fsUtils/TrackingUtils';
import AnchorNav from '../../components/anchor-nav/AnchorNav';


new TopVideoPlayer();
new AnchorNav();

let shareLinks = document.querySelectorAll('.trending-item-share-link');
if(typeof base.analytics !== 'undefined') {	
	const pageMeta = base.analytics.getPageMeta();
	const pageType = pageMeta['page_type'];
	if (shareLinks && shareLinks.length > 0) {
		const utmTerm = (pageType == 'home') ? 'homepage' : (pageType == 'section front') ? 'sf' : 'post';
	
		TrackingUtils.setLinkTracking(shareLinks,'parsely',{
			'utm_campaign'  : 'share_buttons',
			'utm_source'    : 'share_fb',
			'utm_medium'    : 'fscom',
			'utm_content'   : 'original_share',
			'utm_term'		: utmTerm
		});
	}
}
